module.exports = function getCookie(key) {
  if (typeof document !== 'undefined') {
    const cookie = document.cookie;
    const m = cookie.match(new RegExp(`(^| |;)${key}=([^;]*)(;|$)`));
    return !m ? '' : decodeURIComponent(m[2]);
  }
  return '';
};
